<template>
  <span class="svg-ico-line-3-horizontal">
    <svg class="icon-color-1" :style="`width:${width}px; height:${width}px; fill:none;`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73047 7.82812C2.73047 7.41391 3.06626 7.07812 3.48047 7.07812H21.4805C21.8947 7.07812 22.2305 7.41391 22.2305 7.82812C22.2305 8.24234 21.8947 8.57812 21.4805 8.57812H3.48047C3.06626 8.57812 2.73047 8.24234 2.73047 7.82812Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73047 12.8281C2.73047 12.4139 3.06626 12.0781 3.48047 12.0781H21.4805C21.8947 12.0781 22.2305 12.4139 22.2305 12.8281C22.2305 13.2423 21.8947 13.5781 21.4805 13.5781H3.48047C3.06626 13.5781 2.73047 13.2423 2.73047 12.8281Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.73047 17.8281C2.73047 17.4139 3.06626 17.0781 3.48047 17.0781H21.4805C21.8947 17.0781 22.2305 17.4139 22.2305 17.8281C22.2305 18.2423 21.8947 18.5781 21.4805 18.5781H3.48047C3.06626 18.5781 2.73047 18.2423 2.73047 17.8281Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default: '#000000' },
    color2: { type: String, default: '#FFE5E7' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
